import React, { useState } from 'react';
import { useEmail } from '../../context/EmailContext';
import SafeIcon from '../../common/SafeIcon';

const EmailSettings = () => {
  // RETTET: Bruker 'settings' og 'updateSettings' i stedet for policy
  const { settings, updateSettings, dncList, addToDNC } = useEmail();
  const [newDncEmail, setNewDncEmail] = useState('');

  const handleAddDnc = (e) => {
    e.preventDefault();
    if (newDncEmail) {
      addToDNC(newDncEmail, 'Manuelt lagt til');
      setNewDncEmail('');
    }
  };

  // Sikkerhetssjekk i tilfelle settings ikke er lastet
  if (!settings) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Policy Config */}
      <div className="bg-white p-8 rounded-[2rem] border border-slate-200 shadow-sm space-y-6">
        <h3 className="text-lg font-black text-slate-900 flex items-center gap-2">
          <SafeIcon icon="🛡️" className="text-primary-600" /> Policy & Signatur
        </h3>
        
        <div className="space-y-4">
          <label className="flex items-center justify-between p-4 border border-slate-200 rounded-xl cursor-pointer hover:bg-slate-50">
            <div>
              <span className="font-bold text-slate-700 text-sm">Krev manuell sending</span>
              <p className="text-xs text-slate-500">Tvinger brukeren til å kopiere tekst til egen klient.</p>
            </div>
            <input 
              type="checkbox" 
              checked={settings.require_human_send} 
              onChange={e => updateSettings({ require_human_send: e.target.checked })}
              className="w-5 h-5 text-blue-600 rounded"
            />
          </label>

          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Standard Footer (Signatur)</label>
            <textarea 
              value={settings.default_footer} 
              onChange={e => updateSettings({ default_footer: e.target.value })}
              className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 outline-none"
              rows={3}
            />
          </div>
        </div>
      </div>

      {/* DNC List */}
      <div className="bg-white p-8 rounded-[2rem] border border-slate-200 shadow-sm space-y-6">
        <h3 className="text-lg font-black text-slate-900 flex items-center gap-2">
          <SafeIcon icon="🛑" className="text-red-600" /> Do Not Contact (DNC)
        </h3>
        
        <form onSubmit={handleAddDnc} className="flex gap-2">
          <input 
            type="email" 
            placeholder="E-post å blokkere..." 
            value={newDncEmail}
            onChange={e => setNewDncEmail(e.target.value)}
            className="flex-1 px-4 py-2 bg-slate-50 border border-slate-200 rounded-xl text-sm outline-none focus:border-red-500"
          />
          <button type="submit" className="px-4 py-2 bg-red-50 text-red-600 font-bold text-xs rounded-xl hover:bg-red-100 transition-all">
            Legg til
          </button>
        </form>

        <div className="space-y-2 max-h-[300px] overflow-y-auto pr-1 custom-scrollbar">
          {dncList.map((item, idx) => (
            <div key={idx} className="flex justify-between items-center p-3 bg-slate-50 rounded-xl border border-slate-100">
              <span className="text-sm font-medium text-slate-700">{item}</span>
              <span className="text-[10px] text-slate-400 uppercase tracking-widest">Manuelt lagt til</span>
            </div>
          ))}
          {dncList.length === 0 && <p className="text-slate-400 text-sm italic">Ingen blokkeringer.</p>}
        </div>
      </div>
    </div>
  );
};

export default EmailSettings;